export default {
  address: ['user-input', 'map', 'informer'],
  'about-object': [
    'rent-part-house',
    'common/cadastral-number',
    'settlement-name',
    'common/build-year',
    'common/material-type-house',
    'common/suburban-total-area',
    'common/floors-count-house',
    'common/bedrooms-count',
    'beds-count',
    'visual-divider',
    'common/wc-location-type',
    'common/heating-type-house',
    'visual-divider',
    'repair-type',
    'in-house-rent',
    'common/area-land',
  ],
  'price-and-deal-terms': ['price-rent-daily', 'bargain-daily', 'deposit', 'self-employed'],
};
